import React from "react";
import { withFormik } from "formik";
import { FormikPropTypes } from "./helpers/formikPropTypes";
import CompanySelector from "./reusable/companySelector";
import CustomTypeahead from "./fields/CustomTypeahead";
import { getCrewMembers } from "../../services/api/crewMembers";
import { getRegistrations } from "../../services/api/registrations";
import PropTypes from "prop-types";
import { defaultError } from "../../libs/utils";
import BasicSelect from "./fields/BasicSelect";
import CustomDatePicker from "./fields/CustomDatePicker";
import moment from "moment";

class InnerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      crewmembers: [],
      registrationId: undefined,
      vouchers: [],
      vouchersMeta: {}
    };

    this._handleCrewMemberSearch = this._handleCrewMemberSearch.bind(this);
    this._handleNewCrewMember = this._handleNewCrewMember.bind(this);
  }

  static propTypes = {
    event: PropTypes.object,
    cateringOptions: PropTypes.array,
    ...FormikPropTypes
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.values.companyId !== nextProps.values.companyId &&
      nextProps.values.companyId
    ) {
      getRegistrations({
        "filter[event_id]": this.props.event.id,
        "filter[company_id]": nextProps.values.companyId
      }).then(response => {
        if (response.data.length > 0) {
          this.setState({
            registrationId: response.data[0].id
          });
          this.props.setFieldValue("registrationId", response.data[0].id);
        } else {
          defaultError(
            "This company is not working on " + this.props.event.name
          );
          this.props.setFieldValue("companyId", "");
          this.props.setFieldValue("registrationId", "");
        }
      });
    }

    if (
      this.props.values.companyId !== nextProps.values.companyId &&
      !nextProps.values.companyId
    ) {
      this.setState({
        registrationId: undefined
      });
    }
  }

  _handleCrewMemberSearch(value) {
    getCrewMembers({
      "filter[registration_id]": this.state.registrationId,
      "filter[name_like]": value,
      include: "user"
    }).then(response => {
      this.setState({
        crewmembers: response.data
      });
    });
  }

  _handleNewCrewMember(values) {
    if (values.length > 0) {
      this.props.setFieldValue("crewMemberId", values[0].id);
      this.setState({
        latestCrewMember: values[0]
      });
    } else {
      this.props.setFieldValue("crewMemberId", "");
    }
  }

  render() {
    const props = this.props;
    const { crewmembers } = this.state;

    return (
      <form className="m-form" onSubmit={props.handleSubmit}>
        <div className="m-portlet__body">
          <input type="hidden" name="id" />

          <CustomDatePicker {...props} name="day" label="Day" />

          <BasicSelect
            {...props}
            name="catering_option_id"
            options={this.props.cateringOptions.map(option => {
              return { value: option.id, title: option.name };
            })}
            label="Catering Type"
            placeholder="Catering Type"
          />
          {props.values.catering_option_id && (
            <CompanySelector {...props} name="companyId" />
          )}

          {props.values.companyId && (
            <CustomTypeahead
              name="crewMemberId"
              label="Crew Member"
              multiple={false}
              options={crewmembers}
              placeholder="Choose a company"
              labelKey={item => item.user.firstName + " " + item.user.lastName}
              onSearch={this._handleCrewMemberSearch}
              onChange={this._handleNewCrewMember}
              {...this.props}
            />
          )}
        </div>
        <div className="m-portlet__foot">
          <div className="row align-items-center">
            <div className="col-lg-12 m--align-right">
              <button
                type="submit"
                className={
                  "btn m-btn btn-primary" +
                  (props.isSubmitting
                    ? " m-btn--custom m-loader m-loader--light m-loader--left"
                    : "")
                }
                disabled={props.isSubmitting}
              >
                Create
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const CateringClaimsForm = withFormik({
  mapPropsToValues: props => {
    let values = {
      companyId: "",
      day: moment(),
      crewMemberId: "",
      catering_option_id: ""
    };

    return values;
  },
  validate: (values, props) => {
    let errors = {};

    if (!values.companyId || values.companyId === "") {
      errors.companyId = "required";
    }

    if (!values.crewMemberId || values.crewMemberId === "") {
      errors.crewMemberId = "required";
    }

    if (!values.catering_option_id || values.catering_option_id === "") {
      errors.catering_option_id = "required";
    }

    if (!values.day || values.day === "") {
      errors.day = "required";
    }

    return errors;
  },

  handleSubmit: (values, { props, resetForm, setStatus }) => {
    props
      .onSubmit(values)
      .then()
      .catch()
      .then(() => {
        resetForm();
      });
  }
})(InnerForm);

export default CateringClaimsForm;
